import Backbone from 'backbone';

import { template } from '../template';

/**
 * "What's New" monthly digest for admin v1: a single-scroll modal rendering
 * the latest LaunchNotes recap (cover header + one card per launched
 * feature). Opened from the sidebar's What's New link; never auto-opens.
 */
app.WhatsNewModal = Backbone.View.extend({
  className: 'whats-new-modal',
  template: template($('#whats-new-modal-template').html()),

  initialize(options) {
    this.month = options.month;
  },

  setSuperView(superView) {
    this.superView = superView;
  },

  clearState() {
    this.superView = null;
  },

  render() {
    this.superView.$titleLabel.text(`What’s new — ${this.month.label}`);
    this.superView.footer.$el.hide();
    this.superView.setMaxWidth('640px');
    // Features render grouped by chapter (consecutive same-category entries).
    const chapters = [];
    this.month.entries.forEach((entry) => {
      const lastChapter = chapters[chapters.length - 1];
      if (lastChapter && lastChapter.name === entry.category) {
        lastChapter.entries.push(entry);
      } else {
        chapters.push({ name: entry.category, entries: [entry] });
      }
    });
    this.$el.html(this.template({ month: this.month, chapters }));
    return this;
  },
});

let whatsNewPayloadPromise = null;

/**
 * Fetch the whats-new payload once per page load (memoized). Resolves null on
 * failure — the link stays hidden and no error alert is shown.
 */
// Served by Bureau's own resource route (shared with the v2 sidebar), not a maitred
// `{ success, data }` envelope: the digest is the whole response body.
const WHATS_NEW_DATA_URL = '/v2/whats-new/data';

app.WhatsNewModal.fetchPayload = function (callback) {
  if (!whatsNewPayloadPromise) {
    whatsNewPayloadPromise = new Promise((resolve) => {
      app.makeRequestWithOptions({
        method: 'GET',
        url: WHATS_NEW_DATA_URL,
        showAlertOnError: false,
        onSuccess: (_data, response) => resolve(response),
        onFailure: () => resolve(null),
      });
    });
  }
  whatsNewPayloadPromise.then(callback);
};

app.WhatsNewModal.markSeen = function (announcementId, callback) {
  app.makeRequestWithOptions({
    method: 'POST',
    url: WHATS_NEW_DATA_URL,
    data: { announcementId },
    showAlertOnError: false,
    onSuccess: (_data, response) => callback(response?.ok === true),
    onFailure: () => callback(false),
  });
};
